import Joi from 'joi';

export const ProcureSchema = Joi.object({
  projectId: Joi.number().required(),
  provideTypeId: Joi.number().required().min(1),
  receiveBudgetDate: Joi.date().required(),
  projectOwner: Joi.string().required(),
  location: Joi.string().required(),
  realBudget: Joi.number().required().min(1),
  startDate: Joi.date().required(),
  endDate: Joi.date().required(),
});

export const ProcureEndDateSchema = Joi.object({
  endDate: Joi.date().required(),
  remark: Joi.string().required(),
});

export const ProcureAttachmentSchema = Joi.object({
  name: Joi.string().required(),
  file: Joi.string().required(),
});
